import { useEffect, useState } from 'react';
import { useSession } from '../../lib/session';
import { EVENT_NAME } from '../constants';
import { useCurrentUrl } from '../../hooks/useCurrentUrl';

export const PageViewDispatcher = ({ payload }: { payload: Record<string, unknown> }) => {
  const { isACDLenabled, datalayer, updateDatalayer } = useSession();
  const [dataLayerLoaded, setDataLayerLoaded] = useState(false);
  const url = useCurrentUrl();

  useEffect(() => {
    if (!dataLayerLoaded && datalayer && !!isACDLenabled) {
      setDataLayerLoaded(true);
    }
  }, [isACDLenabled, datalayer]);

  useEffect(() => {
    if (!dataLayerLoaded) {
      return;
    }
    // fired once when datalayer is ready (first load) and whenever the URL changes
    pushPageViewEvent();
  }, [dataLayerLoaded, url]);

  function pushPageViewEvent() {
    updateDatalayer({
      event: EVENT_NAME.PAGEVIEW,
      ...payload,
    });
  }
  return <></>;
};
